module.exports = __webpack_public_path__ + "static/media/vf_wknit_core.9709fa08.svg";